import { StyleRulesCallback } from '@material-ui/core/styles/withStyles';

const trainingListStyle: StyleRulesCallback = () => ({});

export default trainingListStyle;
